import React from "react";
import { clientSideCompanyConfig } from "../repositories/clientSideCompanyConfigRepository";

export const ConfigFromServerContext = React.createContext<clientSideCompanyConfig | undefined>(undefined);
